export default __webpack_public_path__ + "da06bc557e264e502427d81a41faba6c.png";